import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CabecalhoMarcaComponent } from '../shared/cabecalho-marca.component';
import { AlertaMensagemComponent } from '../shared/alerta-mensagem.component';
import { NavegacaoAdministrativaComponent } from '../shared/navegacao-administrativa.component';
import { AbaAdministrativa } from '../core/rotas/servico-navegacao-administrativa';

@Component({
  selector: 'app-layout-administrativo',
  standalone: true,
  imports: [CommonModule, CabecalhoMarcaComponent, AlertaMensagemComponent, NavegacaoAdministrativaComponent],
  templateUrl: './layout-administrativo.component.html'
})
export class LayoutAdministrativoComponent {
  @Input() logo = '';
  @Input() iniciais = '';
  @Input() nome = '';
  @Input() agora = new Date();
  @Input() aba: AbaAdministrativa = 'registrador';
  @Input() adminGlobal = false;
  @Input() mensagem = '';
  @Input() ajustesPendentes = 0;
  @Input() feriasPendentes = 0;

  @Output() selecionar = new EventEmitter<string>();
  @Output() menu = new EventEmitter<void>();
  @Output() sair = new EventEmitter<void>();
}
